module.exports = __webpack_public_path__ + "media/alaska/glacier_tracks-0dd7fcc1.jpg";